/**
 * recurring_line_items_controller.js: the recurring job form's line items,
 * through the shared LineItemsManager (static/js/utils/line-items-manager.js),
 * the one line editor every quote, job and invoice host uses.
 *
 * Mounted on form#recurringJobForm (templates/recurring_jobs/form.html). The
 * manager serialises the rows into the form's #line_items_json on every change,
 * and the "Prices are" radios in the totals panel post amounts_are, so the form
 * submits natively. Seeded from #line_items_json, which the server renders with
 * the template's saved lines (or a source job's, when created from one).
 *
 * Config (data-* on the form): currency-symbol, tax-name, tax-rate, vat-rates,
 * tax-exempt, amounts-are.
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["badge", "empty"];

    connect() {
        const ds = this.element.dataset;
        this.manager = new window.LineItemsManager({
            containerId: "lineItemsContainer",
            totalsId: "lineItemsTotals",
            rowIdPrefix: "recurringLineItem_",
            globalFunctionPrefix: "recurring",
            currencySymbol: ds.currencySymbol ?? "$",
            taxName: ds.taxName ?? "GST",
            defaultTaxRate: ds.taxRate ?? 10,
            vatRates: ds.vatRates,
            taxExempt: ds.taxExempt,
            amountsAre: ds.amountsAre,
            elements: {
                subtotal: "lineItemsSubtotal",
                total: "lineItemsTotal",
                lineItemsJson: "line_items_json",
            },
            onBadgeUpdate: (count) => this._showCount(count),
        });
        this.manager.load(this._savedItems());
    }

    add() {
        const row = this.manager.add();
        row?.querySelector('[data-line-item-field="description"]')?.focus();
    }

    _savedItems() {
        try {
            return JSON.parse(document.getElementById("line_items_json").value || "[]");
        } catch {
            return [];
        }
    }

    _showCount(count) {
        if (this.hasBadgeTarget) {
            this.badgeTarget.textContent = count;
            this.badgeTarget.hidden = count === 0;
        }
        if (this.hasEmptyTarget) this.emptyTarget.hidden = this.manager?.hasItems() ?? false;
    }
}
